import auth from '@/router/auth'
import CommentIndex from '@/components/comments/Index'
import CommentCreate from '@/components/comments/Create'
import CommentUpdate from '@/components/comments/Update'
import CommentShow from '@/components/comments/Show'

export default [
  {
    path: '/comments',
    name: 'comments-index',
    component: CommentIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/comments/create',
    name: 'comments-create',
    component: CommentCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/comments/update/:course_id',
    name: 'comments-update',
    component: CommentUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/comments/show/:course_id',
    name: 'comments-show',
    component: CommentShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/comments/router.js